var HASH_UNDEFINED="__lodash_hash_undefined__";function setCacheAdd(_){return this.__data__.set(_,HASH_UNDEFINED),this}module.exports=setCacheAdd;